export interface IEnumValue {
  key?: number | string;
  name?: string;
  displayText?: string;
}
